import { render } from "./UserAccount.vue.js?vue&type=template&id=42eed221!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserAccount.vue?vue&type=template&id=42eed221"
import script from "./UserAccount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/user-settings-page/UserAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42eed221"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42eed221', __exports__)) {
    api.reload('42eed221', __exports__)
  }
  
  module.hot.accept("./UserAccount.vue.js?vue&type=template&id=42eed221!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserAccount.vue?vue&type=template&id=42eed221", () => {
    api.rerender('42eed221', render)
  })

}


export default __exports__